// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Questions tab — shares the section / step-card look of the Interview tab
   (../Interview/interview.css, "iv-" classes); question- and skill-specific
   bits live here with the "q-" prefix.
   ========================================================================== */

.q-step-count {
    flex: 0 0 auto;
    font-size: 11.5px;
    font-weight: 600;
    padding: 2px 10px;
    border-radius: 999px;
    background: #f1f1f1;
    color: #66615b;
    white-space: nowrap;
}

.iv-step.is-open .q-step-count {
    background: rgba(81, 203, 206, .15);
    color: #3aa9ac;
}

/* ---------- Questions inside a step ---------- */
.q-questions {
    padding: 2px 14px 14px 58px;
    min-height: 12px;
}

.q-question {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 12px;
    margin-top: 6px;
    background: #fff;
    border: 1px solid #ececec;
    border-left: 3px solid transparent;
    border-radius: 6px;
    cursor: pointer;
    font-size: 13.5px;
    color: #252422;
    transition: background .15s ease, border-color .15s ease;
}

.q-question:hover {
    background: #f7fdfd;
    border-color: #cfeff0;
}

.q-question.is-selected {
    background: rgba(81, 203, 206, .12);
    border-color: #51cbce;
    border-left-color: #51cbce;
    font-weight: 600;
}

.q-question.is-dragging {
    box-shadow: 0 6px 18px rgba(0, 0, 0, .12);
}

.q-question-icon {
    color: #51cbce;
    font-size: 13px;
}

.q-question-text {
    flex: 1 1;
    min-width: 0;
    overflow-wrap: anywhere;
}

.q-no-questions {
    font-size: 12.5px;
    color: #9a9a9a;
    padding: 8px 2px 0;
}

/* ---------- Skills editor ---------- */
.q-skill-search {
    position: relative;
}

.q-skill-search .form-control {
    border-radius: 6px !important;
    max-height: none !important;
    height: auto;
}

/* Shown inline (not floating) so the tab's scroll area never cuts it off */
.q-skill-suggestions {
    position: static;
    margin-top: 4px;
    max-height: 260px;
    overflow-y: auto;
    background: #fff;
    border: 1px solid #e3e3e3;
    border-radius: 6px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, .12);
}

.q-skill-suggestion {
    padding: 7px 12px;
    font-size: 13px;
    cursor: pointer;
    overflow-wrap: anywhere;
}

.q-skill-suggestion:hover,
.q-skill-suggestion.is-active {
    background: rgba(81, 203, 206, .12);
}

.q-skill-suggestion.is-muted {
    color: #9a9a9a;
    cursor: default;
    font-style: italic;
}

.q-skill-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
}

.q-skill-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    max-width: 100%;
    padding: 5px 6px 5px 12px;
    border-radius: 999px;
    background: rgba(81, 203, 206, .15);
    color: #1f7f82;
    font-size: 12.5px;
    font-weight: 600;
    line-height: 1.3;
}

.q-skill-chip span {
    overflow-wrap: anywhere;
}

.q-skill-chip button {
    border: none;
    background: transparent;
    color: #1f7f82;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    line-height: 1;
    font-size: 15px;
    padding: 0;
    cursor: pointer;
}

.q-skill-chip button:hover {
    background: rgba(31, 127, 130, .15);
}

.q-skill-empty {
    font-size: 12.5px;
    color: #9a9a9a;
    margin-top: 10px;
}

@media (max-width: 576px) {
    .q-questions {
        padding-left: 14px;
    }
}

/* Content stays left-aligned even if a parent centres text */
.iv-page {
    text-align: left;
}

.q-skill-suggestion {
    text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/views/industry/advertisements/Questions/questions.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;;AAE/E;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA,kDAAkD;AAClD;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,wDAAwD;AAC5D;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA,wCAAwC;AACxC;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,YAAY;AAChB;;AAEA,2EAA2E;AAC3E;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,uBAAuB;AAC3B;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,yBAAyB;IACzB,oBAAoB;IACpB,mCAAmC;IACnC,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA,6DAA6D;AAC7D;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["/* ==========================================================================\n   Questions tab — shares the section / step-card look of the Interview tab\n   (../Interview/interview.css, \"iv-\" classes); question- and skill-specific\n   bits live here with the \"q-\" prefix.\n   ========================================================================== */\n\n.q-step-count {\n    flex: 0 0 auto;\n    font-size: 11.5px;\n    font-weight: 600;\n    padding: 2px 10px;\n    border-radius: 999px;\n    background: #f1f1f1;\n    color: #66615b;\n    white-space: nowrap;\n}\n\n.iv-step.is-open .q-step-count {\n    background: rgba(81, 203, 206, .15);\n    color: #3aa9ac;\n}\n\n/* ---------- Questions inside a step ---------- */\n.q-questions {\n    padding: 2px 14px 14px 58px;\n    min-height: 12px;\n}\n\n.q-question {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 9px 12px;\n    margin-top: 6px;\n    background: #fff;\n    border: 1px solid #ececec;\n    border-left: 3px solid transparent;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 13.5px;\n    color: #252422;\n    transition: background .15s ease, border-color .15s ease;\n}\n\n.q-question:hover {\n    background: #f7fdfd;\n    border-color: #cfeff0;\n}\n\n.q-question.is-selected {\n    background: rgba(81, 203, 206, .12);\n    border-color: #51cbce;\n    border-left-color: #51cbce;\n    font-weight: 600;\n}\n\n.q-question.is-dragging {\n    box-shadow: 0 6px 18px rgba(0, 0, 0, .12);\n}\n\n.q-question-icon {\n    color: #51cbce;\n    font-size: 13px;\n}\n\n.q-question-text {\n    flex: 1;\n    min-width: 0;\n    overflow-wrap: anywhere;\n}\n\n.q-no-questions {\n    font-size: 12.5px;\n    color: #9a9a9a;\n    padding: 8px 2px 0;\n}\n\n/* ---------- Skills editor ---------- */\n.q-skill-search {\n    position: relative;\n}\n\n.q-skill-search .form-control {\n    border-radius: 6px !important;\n    max-height: none !important;\n    height: auto;\n}\n\n/* Shown inline (not floating) so the tab's scroll area never cuts it off */\n.q-skill-suggestions {\n    position: static;\n    margin-top: 4px;\n    max-height: 260px;\n    overflow-y: auto;\n    background: #fff;\n    border: 1px solid #e3e3e3;\n    border-radius: 6px;\n    box-shadow: 0 6px 18px rgba(0, 0, 0, .12);\n}\n\n.q-skill-suggestion {\n    padding: 7px 12px;\n    font-size: 13px;\n    cursor: pointer;\n    overflow-wrap: anywhere;\n}\n\n.q-skill-suggestion:hover,\n.q-skill-suggestion.is-active {\n    background: rgba(81, 203, 206, .12);\n}\n\n.q-skill-suggestion.is-muted {\n    color: #9a9a9a;\n    cursor: default;\n    font-style: italic;\n}\n\n.q-skill-chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 12px;\n}\n\n.q-skill-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    max-width: 100%;\n    padding: 5px 6px 5px 12px;\n    border-radius: 999px;\n    background: rgba(81, 203, 206, .15);\n    color: #1f7f82;\n    font-size: 12.5px;\n    font-weight: 600;\n    line-height: 1.3;\n}\n\n.q-skill-chip span {\n    overflow-wrap: anywhere;\n}\n\n.q-skill-chip button {\n    border: none;\n    background: transparent;\n    color: #1f7f82;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    line-height: 1;\n    font-size: 15px;\n    padding: 0;\n    cursor: pointer;\n}\n\n.q-skill-chip button:hover {\n    background: rgba(31, 127, 130, .15);\n}\n\n.q-skill-empty {\n    font-size: 12.5px;\n    color: #9a9a9a;\n    margin-top: 10px;\n}\n\n@media (max-width: 576px) {\n    .q-questions {\n        padding-left: 14px;\n    }\n}\n\n/* Content stays left-aligned even if a parent centres text */\n.iv-page {\n    text-align: left;\n}\n\n.q-skill-suggestion {\n    text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
